module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("“J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN! ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EE")]), _vm._v(", how long’s it been?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy Kramer forgot to take the napkin off his lap as he rose to greet me. It fell straight and true to the floor. Only heavy cloth for Sunday brunch at Joe’s American Bar & Grill.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy, good to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He sat back, crushing a filterless cigarette in an ashtray but not noticing the napkin between his penny loafers. Moving upward, the flannel slacks were gray, the oxford shirt pale blue, the tie a Silk Regent with red background, and the blazer navy blue. Dressing down, for Tommy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I took in the room’s detailed ceilings and mahogany wainscoting, pausing for a moment on the bay window overlooking Newbury Street. The shoppers below bustled around half an hour before the boutiques would open for Christmas-season high rollers. We had a corner all to ourselves, the yuppies holding off until after twelve, when the booze could start to flow.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy’s rounded face seemed to lift a little, making him look younger. “You know, my old law firm used to own this place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I didn’t know. The Boston one, you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, right. Firm got started before the turn of the century, one of the first in the city to decide to make a Jew a partner. When word leaked out about that, the downtown eating clubs very politely told the firm’s established partners, ‘Well, you understand, of course, that we can’t serve him here.’ At which point the partners basically looked at each other, said ‘fuck you’ to the clubs, and bought a restaurant downtown for lunch meetings and this one here in Back Bay for dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So they could eat where they wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“With whoever they wanted, including the new Jewish partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The firm still run the place?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, no. Sometime after I went out on my own in Dedham, they sold it. Back then, though, it was heady stuff for a young lawyer like me to be able to walk into one of the finest restaurants in Boston and be treated like the king of Siam.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Your practice going well?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The practice? Oh, yeah, yeah. Couldn’t be better. We’re at eight attorneys now with the associate we brought in last week. Evening grad from New England.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy’s alma mater. “Kathy and the kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Terrific. She’s gone and got her real estate ticket. Salesman, not broker yet, but that’ll come in time. She’s showing real estate all over town and having a ball. Slow market, like everywhere, but she knows the neighborhoods and the schools. Jason’s on the wrestling team, Kit’s doing indoor—oh, I get it. If everything’s okay on the practice and home fronts, how come I drag you in here on ten hours notice?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A waitress in a tux came to the table and asked if we’d like to order. Both of us went with orange juice, eggs Benedict, and a basket of muffins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When she was beyond earshot, Tommy said, “It’s not for me. It’s for somebody I owe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy’s oblique way of reminding me that I still owed him for a favor.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He coaxed another cigarette from the Camel soft pack. “Okay if I …?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The smoke doesn’t bother me if the surgeon general doesn’t bother you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A match from the little box on the table flared, giving Tommy for an instant the look of a combat soldier, the curly hair still full enough to mimic a helmet. “Who would’ve thought, twenty, thirty years ago that someday you’d have to ask permission to light up?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When I didn’t say anything, he took a deep draw, then put the cigarette down, using the thumb and forefinger of his other hand to tweezer bits of tobacco from his tongue. “The guy approached me because he’s not a lawyer himself, but he wants confidentiality in sounding you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy, the licensing statute requires me to maintain the confidentiality of whatever the client tells me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, right. And this guy knows that. It’s just … well, he wouldn’t exactly be the client.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Somebody wants to talk with me—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Wants me to talk with you—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But this somebody wouldn’t be my actual client?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Our orange juice arrived. I sipped it. Fresh-squeezed, not from concentrate. Like the difference between chardonnay and Ripple. “Okay, I’m still listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A friend of this guy is getting threats.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Threats. Like over the telephone?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Like through the mail. Cut-and-paste jobs using words from magazines.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The friend of the guy been to the police?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The secretary of the friend of the guy tried—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy, this is getting a little out of hand. How about some real names.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He turned that over, shook his head. “How about some titles to make it easier?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Titles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Until you know whether you’re interested or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay. Titles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy pulled on the Camel, wisps of smoke wending out of his nostrils. “The guy I owe, let’s call him the Activist. His friend who’s getting the threats, let’s call the friend the Professor. The Professor’s secretary—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tried going to the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And the cops can’t do much. I’m not into criminal law, but I’m assuming they checked the notes for fingerprints or postmarks and all, and came up empty.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So you want me to do what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I want you to talk to the Activist and the Secretary as my agent, if you’re willing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As your agent.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Talk to them about what, bodyguarding the Professor?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, no. She—they can talk to you more about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Look, John, I know this sucks a little, but like I said, I owe the guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The Activist.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Can you at least tell me how you owe this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy took another puff. “When I was with that firm in Boston, they were real civil rights conscious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good thing to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, well, most of us young associates signed up as volunteers, whatever, for different causes through the BBA.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Boston Bar Association?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, right. I drew …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped, took a puff out of sequence. “I drew this activist, and after I helped him out a couple of times, he started throwing a lot of business my way, business I really needed once I broke off on my own.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Activist, Professor, Secretary.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy, these don’t sound like people who need the layers of confidentiality you’re throwing up around them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, that’s kind of their business, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy, you want me to meet with them, it’s kind of my business, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He put a casual look on his face, checking the room. “This activist, John, he’s … Alec Bacall.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rings a bell somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’s a gay activist, John.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Bacall. Majored in housing and employment rights, minored in AIDS issues. “Tommy, the professor here. Maisy Andrus?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He flinched. “Keep your voice down, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The right-to-die fanatic.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy reddened. “She’s not—” He caught himself speaking too loudly, our waitress thinking he meant her to come over. Tommy shook her off with an apologetic smile.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("More quietly, Tommy said to me, “She’s not a fanatic, John. She was a professor of mine, back in law school.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“At Boston College?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, right. Before she went over to Mass Bay.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I waited for Tommy to say something about my year as a student at the Law School of Massachusetts Bay. He didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I said, “So Andrus was a professor of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And she helped me get that first job, at the law firm. Letter of recommendation, couple of phone calls, I found out later.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So you owe her too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And now she’s being threatened.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy ground out the cigarette. “Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And she turns to you to turn to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, no, Alec—Bacall—is the one who called me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I sat back. Watching him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s the matter, John?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Quite a coincidence.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You contacting me to maybe help these people who preach the quick-and-happy ending.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tommy looked very uncomfortable. Which was as good an answer as my next question could bring.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, look—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tommy. I lost Beth to cancer, slowly. Bacall pushes the right to die for AIDS victims, Andrus casts a wider net. I’m the first one you think of?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, I’m sorry. I should have … Look, I owe these people. From a long time ago, but I owe them. I once mentioned to Alec about Beth. Not directly, just that I could understand his position because I had a good friend who became a private investigator partly because his wife died. I never used your name or Beth’s, it was just …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“An example.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah. I’m sorry, but yeah. Then Alec calls me yesterday, and the guy’s got a mind like a steel trap. He remembers me mentioning your situation, John. And he asks me to ask you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Picking up my orange juice, I pictured Tommy dropping everything to help me with Empire and with Beth. To Tommy bailing me out when I was filling a hospital bed, a bullet hole in my shoulder and a skeptical D.A. on my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ll talk to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Great, great. Uh, John?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Today maybe?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy was at work, catching up on some research. After one more stop in the neighborhood, I’d be free for the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Two o’clock, Tommy. My office on Tremont Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Alec said he’d be at the professor’s house, so I’ll call them now. I really appreciate this, John.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Getting up, Tommy got his feet tangled in the napkin and nearly fell into our waitress and eggs Benedict.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511a7740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-chap2.vue
// module id = 75
// module chunks = 0